import {useContext, useMemo} from 'react';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {LanguageContext} from '../../../../../../contexts/LanguageContext/LanguageContext';
import {ApplicantSkill} from '../../../../../../types/applicantSkill/ApplicantSkill';

export const useSkillsSection = (applicantSkills: ApplicantSkill[]): FormSection[] => {
  const currentLanguage = useContext(LanguageContext);

  return useMemo<FormSection[]>(
    () => [
      {
        type: 'skills',
        data: {
          name: 'skills',
          initialValue: (applicantSkills || []).map((skill) => ({
            id: skill.standardSkill.resourceId,
            name: skill.standardSkill.name[currentLanguage],
            category: skill.category,
          })),
        },
      },
    ],
    [applicantSkills, currentLanguage]
  );
};
